
class CutCalculatorQuantity extends HTMLElement {
    constructor() {
        super();
        this.minusButton = null;
        this.plusButton = null;
        this.input = null;
        this.output = null;
        this.step = 1;
        this.min = null;
        this.max = null;
    }

    connectedCallback() {
        this.minusButton = this.querySelector('[data-minus]');
        this.plusButton = this.querySelector('[data-plus]');
        this.input = this.querySelector('input[type="number"]');
        this.output = this.querySelector('input[readonly]');
        this.propertyLengthName = this.querySelector('input[id="cutCalculatorLength"]');
        this.propertyDataName = this.propertyLengthName.getAttribute('data-property-data-name');
        this.externalPrice = document.querySelector('.product__content .product__price .price__regular [data-price-value]');
        this.externalComparePrice = document.querySelector('.product__content .product__price .price__sale-inner [data-price-value]');
        this.timestamp = this.querySelector('input[id="cutCalculatortimestamp"]');


        if (!this.input) return;

        this.step = parseFloat(this.input.getAttribute('step')) || 1;
        this.min = this.input.hasAttribute('min') ? parseFloat(this.input.getAttribute('min')) : null;
        this.max = this.input.hasAttribute('max') ? parseFloat(this.input.getAttribute('max')) : null;

        this.settings = {
            price: parseFloat(this.externalPrice?.getAttribute('data-price-value') / 100) || 0,
            comparePrice: parseFloat(this.externalComparePrice?.getAttribute('data-price-value') / 100) || 0,
            currency: this.getAttribute('data-currency') || 'USD',
        };

        this.eventListeners();

        // Initial update
        this.updateOutput();
    }

    disconnectedCallback() {
        this.removeEventListeners();
    }


    eventListeners() {
        if (this.minusButton) {
            this.minusButton.addEventListener('click', () => this.adjustValue(-1));
        }
        if (this.plusButton) {
            this.plusButton.addEventListener('click', () => this.adjustValue(1));
        }
        if (this.input) {
            this.input.addEventListener('change', this.onInput.bind(this));
            this.input.addEventListener('click', this.selectInput.bind(this));
        }

        if (this.timestamp) {
            document.addEventListener('cart:updated', this.updateTimestamp.bind(this));
        }
    }

    removeEventListeners() {
        if (this.minusButton) {
            this.minusButton.removeEventListener('click', () => this.adjustValue(-1));
        }
        if (this.plusButton) {
            this.plusButton.removeEventListener('click', () => this.adjustValue(1));
        }
        if (this.input) {
            this.input.removeEventListener('change', this.onInput.bind(this));
            this.input.removeEventListener('click', this.selectInput.bind(this));
        }
    }



    adjustValue(direction) {
        let value = parseFloat(this.input.value) || 0;
        value += this.step * direction;
        if (this.min !== null && value < this.min) value = this.min;
        if (this.max !== null && value > this.max) value = this.max;
        this.input.value = value;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.updateOutput();

        this.minusButton.disabled = value <= this.min;
        this.plusButton.disabled = value >= this.max;
    }

    onInput() {
        let value = parseFloat(this.input.value) || 0;

        // Round value according to step
        if (this.step && this.step > 0) {
            // Find the closest multiple of step, starting from min if defined, else from 0
            let base = this.min !== null ? this.min : 0;
            value = Math.round((value - base) / this.step) * this.step + base;
            // Fix floating point precision issues
            value = parseFloat(value.toFixed(6));
            this.input.value = value;
        }

        if (this.min !== null && value < this.min) {
            value = this.min;
            this.input.value = value;
        }
        if (this.max !== null && value > this.max) {
            value = this.max;
            this.input.value = value;
        }

        this.adjustValue(0);

        this.updateOutput();
        this.updateTimestamp();
    }

    updateOutput() {
        if (!this.output) return;
        let value = parseFloat(this.input.value) || 0;
        // Convert cm to meters (assuming input is in cm)
        this.output.value = (value / 100).toFixed(2);
        this.updatePrice();
        this.updateProperty();
    }

    updateTimestamp() {
        if (!this.timestamp) return;
        this.timestamp.value = `${Date.now()}`;
    }

    updatePrice() {
        if (this.externalPrice) {
            let valueInCentimeters = parseFloat(this.input.value) || 0;
            const newPrice = (this.settings.price * valueInCentimeters).toFixed(2);
            this.externalPrice.innerHTML = `${ newPrice } ${ this.settings.currency }`;
        }
        if (this.externalComparePrice) {
            let valueInCentimeters = parseFloat(this.input.value) || 0;
            const newPrice = (this.settings.comparePrice * valueInCentimeters).toFixed(2);
            this.externalComparePrice.innerHTML = `${ newPrice } ${ this.settings.currency }`;
        }
    }

    updateProperty() {
        if (!this.propertyLengthName) return;
        this.propertyLengthName.value = `${this.input.value} ${this.propertyDataName}`;
    }

    selectInput() {
        this.input.select();
    }
}

if (!customElements.get('cut-calculator-quantity')) {
    customElements.define('cut-calculator-quantity', CutCalculatorQuantity);
}
